"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iNonEmptyString = exports.NonEmptyStringType = exports.iLimitAndOffsetFront = exports.iLimitAndOffsetApi = exports.iOrder = exports.UUID = void 0;
const t = require("io-ts");
const UUIDRegexp = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
exports.UUID = t.refinement(t.string, (s) => UUIDRegexp.test(s), 'UUID');
exports.iOrder = t.union([t.literal('asc'), t.literal('desc')]);
exports.iLimitAndOffsetApi = t.partial({
    limit: t.string,
    offset: t.string
});
exports.iLimitAndOffsetFront = t.interface({
    limit: t.number,
    offset: t.number
});
class NonEmptyStringType extends t.Type {
    constructor() {
        super('NonEmptyStringType', (v) => typeof v === 'string' && v.length > 0, (v, c) => t.string.validate(v, c).chain((s) => {
            return s.length > 0 ? t.success(s) : t.failure(s, c);
        }), t.identity);
        this.tag = 'NonEmptyStringType';
    }
}
exports.NonEmptyStringType = NonEmptyStringType;
exports.iNonEmptyString = new NonEmptyStringType();
//# sourceMappingURL=generic.js.map